import 'bootstrap-icons/font/bootstrap-icons.css';
import 'bootstrap/dist/css/bootstrap.css';
import React from "react";
import { withTranslation } from "react-i18next";
import { Link } from "react-router-dom";
import smallLogo from "../../assets/images/heart.png";
import fullLogo from "../../assets/images/logo.png";
import '../Style/index.css';

export interface AdminSidebarProps {
  showNav: boolean;
}

const AdminSidebar: React.FC<AdminSidebarProps> = ({
  showNav,
}) => {

  return (
    <React.Fragment>
      <div className={`l-navbar${showNav ? ' l-show' : ''}`}>
        <nav className="custom_nav border-end">
          <div className="container-fluid " >
            <div className="align-items-left text-start">
              <div className="nav_list">
                <Link
                  to="/admin-ticketing"
                  className="nav_logo"
                >
                  <span className="nav_logo-icon">
                    {showNav
                      ? <img src={fullLogo} />
                      : <img style={{ height: 60, marginLeft: -20 }} src={smallLogo} />
                    }
                  </span>
                </Link>
                <Link
                  to="/admin-ticketing"
                  className="nav_link"
                >
                  <i className="bi bi-ticket-perforated nav_icon" />
                  <span className="nav_name"> Ticketing </span>
                </Link>
                <Link
                  to="/organisations"
                  className="nav_link"
                >
                  <i className='bi bi-grid nav_icon' />
                  <span className="nav_name">  Organizations </span>
                </Link>
              </div>
            </div>
          </div>
        </nav>
      </div>
    </React.Fragment>
  );
};

export default withTranslation()(AdminSidebar);
